export const contactsData = {
    email: 'pruthiltejani.work@gmail.com',
    phone: '+91 97128 32215',
    address: 'Surat, Gujarat, India - 395013',

    sheetAPI: ''
}